import { AppLinks } from 'enviroment/AppLinks'
import { ChooseIdentityMethodTypes } from 'pages/ChooseIdentityMethodPage/ChooseIdentityMethodPageProps'
import { IGenerateSessionResponse } from 'service/VideoVerificationService/VideoVerificationServiceProps'


/**
 * Funkcja przyjmująca parametry z backendu i tworząca link do identyfikacji w procesie wideo weryfikacji
 * @returns { String }
 */
export const createVideoVerificationIdentificationLink = (props: IGenerateSessionResponse): string => {
   const VIDEO_VERIFICATION_PATH = '/self-verify'
   const redirectAfterVerificationUrl = new URL(AppLinks.videoVerificationBackFromPartner, window.location.origin)
   const baseUrl = new URL(VIDEO_VERIFICATION_PATH, props.videoVerificationUrl)
   redirectAfterVerificationUrl.searchParams.append("identity_method_type", props.chooseIdentityMethodType.toLowerCase()) //Customowy parametr, mówiący o tym na jakim etapie procesu użytkownik wybrał wideo weryfikację.
   
   const returnUrl = new URL ( // URL wykorzystywany do przekierowania użytkownika z powrotem na stronę wyboru metody identyfikacji lub weryfikacji w przypadku zrezygnowania z wideo weryfikacji
      props.chooseIdentityMethodType === ChooseIdentityMethodTypes.IDENTITY ? AppLinks.chooseIdentityMethod : AppLinks.chooseVerificationMethod,
      window.location.origin
   ) 

   const linkQueryParams = new URLSearchParams({
      document_id: props.documentId,
      session_id: props.sessionId,
      redirect_url: encodeURI(redirectAfterVerificationUrl.href), // encodeURI -  wymagane enkodowanie - według dokumentacji
      return_url: encodeURI(returnUrl.href),
      lang: 'pl',
   })

   return `${baseUrl.href}?${linkQueryParams.toString()}`
}